import * as z from 'zod';
export const formAuthenticationSchema = z.object({
  username: z.string().min(5, { message: 'Tài khoản yêu cầu bắt buộc.' }),
  password: z.string().min(5, { message: 'Mật khẩu yêu cầu bắt buộc' })
});

export type FormAuthenticationSchema = z.infer<typeof formAuthenticationSchema>

export const profileSchema = z.object({
  firstname: z
    .string()
    .min(3, { message: 'Product Name must be at least 3 characters' }),
  lastname: z
    .string()
    .min(3, { message: 'Product Name must be at least 3 characters' }),
  email: z
    .string()
    .email({ message: 'Product Name must be at least 3 characters' }),
  contactno: z.coerce.number(),
  country: z.string().min(1, { message: 'Please select a category' }),
  city: z.string().min(1, { message: 'Please select a category' }),
  // jobs array is for the dynamic fields
  jobs: z.array(
    z.object({
      jobcountry: z.string().min(1, { message: 'Please select a category' }),
      jobcity: z.string().min(1, { message: 'Please select a category' }),
      jobtitle: z
        .string()
        .min(3, { message: 'Product Name must be at least 3 characters' }),
      employer: z
        .string()
        .min(3, { message: 'Product Name must be at least 3 characters' }),
      startdate: z
        .string()
        .refine((value) => /^\d{4}-\d{2}-\d{2}$/.test(value), {
          message: 'Start date should be in the format YYYY-MM-DD'
        }),
      enddate: z.string().refine((value) => /^\d{4}-\d{2}-\d{2}$/.test(value), {
        message: 'End date should be in the format YYYY-MM-DD'
      })
    })
  )
});

export type ProfileFormValues = z.infer<typeof profileSchema>;

export const serviceSchema = z.object({
  apiEndpoint: z
    .string()
    .min(5, { message: 'Api Endpoint phải có ít nhất 5 kí tự' }),
  serviceApi: z
    .string()
    .min(5, { message: 'Service Api phải có ít nhất 5 kí tự' }),
  functionApi: z
    .string()
    .min(5, { message: 'Function Api phải có ít nhất 5 kí tự' }),
});

export type ServiceFormValues = z.infer<typeof serviceSchema>;


export const createServiceSchema = z.object({
  namePackage: z
    .string()
    .min(5, { message: 'Tên gói phải có ít nhất 5 kí tự' }),
  price: z
    .string()
    .min(1, { message: 'Giá của gói phải lớn hơn 1 VNĐ' }),
  discount: z
    .string()
    .min(0, { message: 'Discount của gói phải lớn hơn 0' }),
  billingCycle: z
    .string()
    .min(0, { message: 'Chu kì thanh toán phải lớn hơn 0' }),
  numberCycleBenefit: z
    .string()
    .min(0, { message: 'Số chu kì hưởng phải lớn hơn 0' })
});

export type CreateServiceFormValues = z.infer<typeof createServiceSchema>;

export const updateCustomerInfo = z.object({
  phone: z
    .string()
    .optional()
    .refine((value) => !value || /^\d{10}$/.test(value), { message: 'Số điện thoại phải bao gồm đúng 10 chữ số' }),
  email: z
    .string()
    .optional()
    .refine((value) => !value || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value), { message: 'Email không hợp lệ' }),
  birthdate: z.date().optional(),  // Allow optional birthdate
  user_name: z.string().optional(),
  full_name: z.string().optional(),
});

export type UpdateCustomerInfo = z.infer<typeof updateCustomerInfo>;

const optionalIntNonNegative = z.preprocess(
  (value) => {
    if (value === '' || value === null || value === undefined) {
      return undefined;
    }
    return typeof value === 'number' ? value : Number(value);
  },
  z.number({ invalid_type_error: 'Giá trị không hợp lệ' })
    .int({ message: 'Phải là số nguyên' })
    .min(0, { message: 'Giá trị phải lớn hơn hoặc bằng 0' })
    .optional()
);

const requiredIntNonNegative = z.preprocess(
  (value) => {
    if (value === '' || value === null || value === undefined) {
      return Number.NaN;
    }
    return typeof value === 'number' ? value : Number(value);
  },
  z.number({ invalid_type_error: 'Giá trị không hợp lệ' })
    .int({ message: 'Phải là số nguyên' })
    .min(0, { message: 'Giá trị phải lớn hơn hoặc bằng 0' })
);
export const extendPackageService = z.object({
  expirationDate:
    z.date(),
  paymentAmount:
    requiredIntNonNegative,
  paymentMethod:
    z.string().min(1, { message: 'Phương thức thanh toán không được để trống' }),
  description: z.string().min(1, { message: 'Mô tả không được để trống' }),
  featureAmount: optionalIntNonNegative,
});

export type ExtendPackageService = z.infer<typeof extendPackageService>;

export const cancelSubscriptionSchema = z.object({
  isRefund: z.boolean(),
  paymentMethod: z.string().min(1, { message: 'Phương thức thanh toán không được để trống' }),
  amount: z.number().min(0, { message: 'Số tiền hoàn trả phải lớn hơn hoặc bằng 0' }),
  description: z.string().min(1, { message: 'Mô tả không được để trống' }),
});

export type CancelSubscriptionSchema = z.infer<typeof cancelSubscriptionSchema>;

export const addBeneficiaryAccountReq = z.object({
  bank_name: z.string().min(1, { message: 'Tên ngân hàng phải có ít nhất 1 kí tự' }),
  account_name: z.string().min(3, { message: 'Chủ tài khoản phải có ít nhất 3 kí tự' }),
  account_number: z.string().min(10, { message: 'Số tài khoản phải ít nhất 10 chữ số' }),
  default_account: z.boolean().optional(),
});
export type AddBeneficiaryAccountSchema = z.infer<typeof addBeneficiaryAccountReq>;


export const changePasswordUser = z
  .object({
    password: z
      .string()
      .min(8, { message: 'Mật khẩu phải có ít nhất 8 kí tự' })
      .regex(/[A-Z]/, { message: 'Mật khẩu phải chứa ít nhất 1 ký tự viết hoa' })
      .regex(/[a-z]/, { message: 'Mật khẩu phải chứa ít nhất 1 ký tự viết thường' })
      .regex(/\d/, { message: 'Mật khẩu phải chứa ít nhất 1 ký tự số' })
      .regex(/[!@#$%^&*(),.?":{}|<>]/, { message: 'Mật khẩu phải chứa ít nhất 1 ký tự đặc biệt' }),
    rePassword: z.string().min(8, { message: 'Mật khẩu nhập lại phải có ít nhất 8 kí tự' }),
  })
  .refine((data) => data.password === data.rePassword, {
    message: 'Mật khẩu nhập lại không khớp',
    path: ['rePassword'],
  });
export type ChangePasswordUserSchemas = z.infer<typeof changePasswordUser>;

export const addProxySchemas = z.object({
  provider: z
    .string()
    .min(1, { message: "Nhà cung cấp không được để trống" })
    .max(100, { message: "Tên nhà cung cấp tối đa 100 ký tự" }),

  fullProxy: z
    .string()
    .min(1, { message: "Proxy không được để trống" }),

  maxUsage: z.string(),

  status: z.string(),

  expired: z
    .date({ invalid_type_error: "Ngày hết hạn không hợp lệ" })
    .refine((d) => d > new Date(), {
      message: "Ngày hết hạn phải là ngày trong tương lai",
    }),

  note: z
    .string()
    .max(1000, { message: "Ghi chú không quá 1000 ký tự" })
    .optional()
    .or(z.literal("")), // Cho phép chuỗi rỗng
});

export type AddProxySchemas = z.infer<typeof addProxySchemas>;

export const addProxyFromFileSchemas = z.object({
  provider: z
    .string()
    .min(1, { message: "Nhà cung cấp không được để trống" })
    .max(100, { message: "Tên nhà cung cấp tối đa 100 ký tự" }),
  file: z
    .instanceof(File, { message: "Vui lòng chọn một tệp hợp lệ" })
    .refine((file) => file.size > 0, { message: "File không được rỗng" }),
  expired: z
    .date({ invalid_type_error: "Ngày hết hạn không hợp lệ" })
    .refine((d) => d > new Date(), {
      message: "Ngày hết hạn phải là ngày trong tương lai",
    }),
  maxUsage: z.string(),
  status: z.string(),
  note: z
    .string()
    .max(1000, { message: "Ghi chú không quá 1000 ký tự" })
    .optional()
    .or(z.literal("")),
})

export type AddProxyFromFileSchemas = z.infer<typeof addProxyFromFileSchemas>


export const updateProxySchemas = z.object({
  provider: z
    .string()
    .min(1, { message: "Nhà cung cấp không được để trống" })
    .max(100, { message: "Tên nhà cung cấp tối đa 100 ký tự" }),

  fullProxy: z
    .string()
    .min(1, { message: "Proxy không được để trống" }),

  maxUsage: z.string(),
  current_usage: z.string(),

  status: z.string(),

  expired: z
    .date({ invalid_type_error: "Ngày hết hạn không hợp lệ" })
    .refine((d) => d > new Date(), {
      message: "Ngày hết hạn phải là ngày trong tương lai",
    }),

  note: z
    .string()
    .max(1000, { message: "Ghi chú không quá 1000 ký tự" })
    .optional()
    .or(z.literal("")),
});

export type UpdateProxySchemas = z.infer<typeof updateProxySchemas>;

export const addNotificationSchemas = z.object({
  title: z
    .string()
    .min(1, { message: 'Tiêu đề thông báo không được để trống' })
    .max(255, { message: 'Tiêu đề thông báo tối đa 255 ký tự' }),
  content: z
    .string()
    .min(1, { message: 'Nội dung thông báo không được để trống' })
    .max(5000, { message: 'Nội dung thông báo tối đa 1000 ký tự' }),
  topic: z
    .string()
    .min(1, { message: 'Chủ đề thông báo không được để trống' })
    .max(255, { message: 'Chủ đề thông báo tối đa 255 ký tự' }),
  scheduled_time: z
    .date({ invalid_type_error: 'Thời gian lên lịch không hợp lệ' })
    .refine((d) => d > new Date(), {
      message: 'Thời gian lên lịch phải là thời gian trong tương lai',
    }),
  draft: z.boolean().optional().default(false),
});

export type AddNotificationSchemas = z.infer<typeof addNotificationSchemas>;

// Staff schemas
export const addStaffSchema = z.object({
  login_name: z
    .string()
    .min(3, { message: 'Tên đăng nhập phải có ít nhất 3 ký tự' })
    .max(50, { message: 'Tên đăng nhập tối đa 50 ký tự' })
    .regex(/^[a-zA-Z0-9_]+$/, { message: 'Tên đăng nhập chỉ chứa chữ cái, số và dấu gạch dưới' }),
  full_name: z
    .string()
    .min(2, { message: 'Họ và tên phải có ít nhất 2 ký tự' })
    .max(100, { message: 'Họ và tên tối đa 100 ký tự' }),
  email: z
    .string()
    .email({ message: 'Email không hợp lệ' }),
  phone: z
    .string()
    .regex(/^\d{10}$/, { message: 'Số điện thoại phải có đúng 10 chữ số' }),
  password: z
    .string()
    .min(8, { message: 'Mật khẩu phải có ít nhất 8 ký tự' }),
});

export type AddStaffSchema = z.infer<typeof addStaffSchema>;

export const updateStaffSchema = z.object({
  full_name: z
    .string()
    .min(2, { message: 'Họ và tên phải có ít nhất 2 ký tự' })
    .max(100, { message: 'Họ và tên tối đa 100 ký tự' }),
  email: z
    .string()
    .email({ message: 'Email không hợp lệ' }),
  phone: z
    .string()
    .regex(/^\d{10}$/, { message: 'Số điện thoại phải có đúng 10 chữ số' }),
});

export type UpdateStaffSchema = z.infer<typeof updateStaffSchema>;

export const changeStaffPasswordSchema = z.object({
  new_password: z
    .string()
    .min(8, { message: 'Mật khẩu phải có ít nhất 8 ký tự' }),
  confirm_password: z
    .string()
    .min(1, { message: 'Xác nhận mật khẩu là bắt buộc' }),
}).refine((data) => data.new_password === data.confirm_password, {
  message: 'Mật khẩu xác nhận không khớp',
  path: ['confirm_password'],
});

export type ChangeStaffPasswordSchema = z.infer<typeof changeStaffPasswordSchema>;
